import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const cardStyle = style({});

export const graphStyle = style({
  width: "100%",
  maxWidth: rem(500),
  transform: "translateX(-5%)",
});
